import styled from "styled-components";

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #191c1a;
`;

export const Label = styled.span`
  font-size: 14px;
  color: #6f6f78;
`;

export const TableLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgb(111, 111, 120);
  font-weight: 400;
`;

export const TableText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #191c1a;
`;
